import { ITestPlanInstrument } from "./TestplanInstrument";
import { IInstrumentPartition, InstrumentPartition } from "./InstrumentPartition";

export class TestplanInstrumentOperations {

    public static updatePartition(instrument: ITestPlanInstrument, partition: IInstrumentPartition): void {
        partition.isEdit = false;
        instrument.partitions[partition.index] = partition;
    }

    public static setPositionWidth(instrument: ITestPlanInstrument, value: number) {
        if (instrument.isFixedPosition) {
            instrument.positionWidth = value;
            instrument.fixedPositionWidth = value;
        } else if (instrument.partitionsCount > 0) {
            instrument.positionWidth = Math.round(instrument.stripLength / instrument.partitionsCount);
        }
        this.setPartitionsPositionWidth(instrument);
    }

    private static setPartitionsPositionWidth(instrument: ITestPlanInstrument) {
        instrument.partitions.forEach((d) => {
            d.positionWidth = instrument.positionWidth;
        });
    }

    public static setInstrumentStripLength(instrument: ITestPlanInstrument, value: number): void {
        instrument.stripLength = value;
        this.setPositionWidth(instrument, 0);
    }

    public static setIsFixedPosition(instrument: ITestPlanInstrument, value: boolean) {
        instrument.isFixedPosition = value;
        if (value === false && instrument.fixedPositionWidth !== 0) {
            this.setPositionWidth(instrument, 0);
        }
        if (!value) {
            instrument.fixedPositionWidth = 0;
        }
    }

    public static setPartitions(instrument: ITestPlanInstrument, partitionsCount: number) {
        instrument.partitionsCount = partitionsCount;
        this.setPositionWidth(instrument, 0);
        instrument.partitions.splice(0);
        for (let index = 0; index < instrument.partitionsCount; index++) {
            instrument.partitions.push(new InstrumentPartition(index, instrument.positionWidth, instrument.directions, instrument.defaultCount,
                "", instrument.isFixedPosition));
        }
    }

    public static removePartition(instrument: ITestPlanInstrument, partition: IInstrumentPartition) {
        if (instrument.partitionsCount > 0) {
            instrument.partitionsCount = instrument.partitionsCount - 1;
            instrument.partitions.splice(partition.index, 1);
        }
    }

    public static validatePartition(instrument: ITestPlanInstrument, partition: IInstrumentPartition, newPositionWidth: number) {
        let allowedPositionWidth = instrument.stripLength;
        instrument.partitions.forEach(element => {
            if (element.index !== partition.index) {
                allowedPositionWidth -= element.positionWidth
            }
        });
        if (newPositionWidth > allowedPositionWidth)
            return false;
        return true;
    }

    public static isValid(stripLength: number, fixedPositionWidth: number, partitionsCount: number, isFixedPosition: boolean) {
        // strip length should be greater than fixedPosition * Positions
        if (isFixedPosition) {
            if ((stripLength >= fixedPositionWidth * partitionsCount))
                return true;
            return false;
        }
        return true;
    }
}